import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "reports-component position-relative" }
const _hoisted_2 = { class: "card position-relative" }
const _hoisted_3 = { class: "d-flex dropdown-menu-card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_5 = { class: "menu-link px-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "card-body pt-8" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-7" }
const _hoisted_14 = { class: "multi-select-component" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Dimensions", -1)
const _hoisted_16 = { class: "lists" }
const _hoisted_17 = { class: "multi-list all-items" }
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid form-check-sm" }
const _hoisted_19 = ["onUpdate:modelValue", "id"]
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "multi-list selected-items" }
const _hoisted_22 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid form-check-sm"
}
const _hoisted_23 = ["onUpdate:modelValue", "id"]
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "col-md-8" }
const _hoisted_26 = { class: "filters" }
const _hoisted_27 = { class: "filters-title" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "filters-title-text" }, "Filters", -1)
const _hoisted_29 = { class: "section-heading-toolbar" }
const _hoisted_30 = { class: "filters-container" }
const _hoisted_31 = { class: "mb-3 filters-wrapper" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "clearfix" }, " ", -1)
const _hoisted_34 = { class: "report-table-wrapper" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table table-bordered table-statistics" }
const _hoisted_37 = { class: "fw-bolder text-muted bg-light text-uppercase" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "col-dimension" }
const _hoisted_40 = { class: "summary-row" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "col-dimension" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "col-dimension" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 2,
  class: "not-entity"
}
const _hoisted_47 = {
  key: 3,
  class: "not-entity"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "summary-row" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "col-dimension" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_toolbar_menu = _resolveComponent("card-toolbar-menu")!
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_filters_statistics = _resolveComponent("filters-statistics")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_sort_column = _resolveComponent("sort-column")!
  const _component_entity = _resolveComponent("entity")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_card_toolbar_menu, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-light-primary me-3 no-btn-styling btn-sm",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadData(true)))
              }, _hoisted_8)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_dw_loader, { active: _ctx.busy }, null, 8, ["active"]),
        _createElementVNode("form", {
          class: "compact-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.loadData(false, true)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (d) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input h-15px w-15px",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((d._selected) = $event),
                              id: 'label-d-'+d.label
                            }, null, 8, _hoisted_19), [
                              [_vModelCheckbox, d._selected]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label",
                              for: 'label-d-'+d.label
                            }, _toDisplayString(d.label), 9, _hoisted_20)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dimensions, (d) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (d._selected)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input h-15px w-15px",
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((d._selected) = $event),
                                    id: 'label-d-'+d.label
                                  }, null, 8, _hoisted_23), [
                                    [_vModelCheckbox, d._selected]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: 'label-d-'+d.label
                                  }, _toDisplayString(d.label), 9, _hoisted_24)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("a", {
                      class: "clear-all",
                      href: "javascript:void(0)",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearAll()))
                    }, "Clear")
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_filters_statistics, {
                      filters: _ctx.filters,
                      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
                      busy: _ctx.busy,
                      "onUpdate:busy": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.busy) = $event))
                    }, null, 8, ["filters", "busy"])
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-sm",
                    type: "submit",
                    disabled: _ctx.busy
                  }, "Go", 8, _hoisted_32)
                ])
              ])
            ])
          ])
        ], 32),
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_pagination, {
            class: "mb-4",
            modelValue: _ctx.pagination,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination) = $event)),
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadData()))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("table", _hoisted_36, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_37, [
                  (_ctx.metaData.group_timeframe)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_38, " "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.dimensions, (d) => {
                    return (_openBlock(), _createElementBlock("th", _hoisted_39, _toDisplayString(d.short_label || d.label), 1))
                  }), 256)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.metrics, (m) => {
                    return (_openBlock(), _createBlock(_component_sort_column, {
                      class: _normalizeClass(["col-metric", 'col-'+m.name]),
                      onSort: _ctx.loadData,
                      sorter: _ctx.sortBy,
                      "onUpdate:sorter": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sortBy) = $event)),
                      field: m.name
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(m.short_label || m.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onSort", "sorter", "field", "class"]))
                  }), 256))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_40, [
                _createElementVNode("tr", null, [
                  (_ctx.metaData.group_timeframe)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_41, " "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.dimensions, (d) => {
                    return (_openBlock(), _createElementBlock("td", _hoisted_42, " "))
                  }), 256)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.metrics, (m) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass(["col-metric", 'col-'+m.name])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.summary[m.name].toLocaleString()), 1)
                    ], 2))
                  }), 256))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(_ctx.getRowClass(r)),
                    style: _normalizeStyle({backgroundColor: _ctx.notes_map[r.offer_id] ? "#c5bdff" : ""})
                  }, [
                    (_ctx.metaData.group_timeframe)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(r.group_time), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.dimensions, (d) => {
                      return (_openBlock(), _createElementBlock("td", _hoisted_44, [
                        (r[d.name] && r[d.name].id && d.name !== 'sub1')
                          ? (_openBlock(), _createBlock(_component_entity, {
                              key: 0,
                              id: r[d.name].id,
                              name: r[d.name].name,
                              type: d.name,
                              onClickCallback: _ctx.entityClicked,
                              params: r[d.name].params
                            }, null, 8, ["id", "name", "type", "onClickCallback", "params"]))
                          : _createCommentVNode("", true),
                        (r[d.name] && r[d.name].id && d.name === 'sub1')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(r[d.name].name), 1))
                          : _createCommentVNode("", true),
                        (!r[d.name] || !r[d.name].id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(r[d.field]), 1))
                          : _createCommentVNode("", true),
                        (d.name === 'fallback_url')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(r.placement.fallback_url), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.metrics, (m) => {
                      return (_openBlock(), _createElementBlock("td", {
                        class: _normalizeClass(["col-metric", 'col-'+m.name + ' flag-' + r[m.name].flag + ' ' + _ctx.getColumnClass(r, m)])
                      }, [
                        _createVNode(_component_el_tooltip, {
                          content: (r[m.name].label || r[m.name].name) || '',
                          disabled: !((r[m.name].label || r[m.name].name) || '')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              (!_ctx.metricsHash[m.name] || !_ctx.metricsHash[m.name].link)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(r[m.name].v?.toLocaleString()), 1))
                                : _createCommentVNode("", true),
                              (_ctx.metricsHash[m.name] && _ctx.metricsHash[m.name].link)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(r[m.name].v?.toLocaleString()), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["content", "disabled"])
                      ], 2))
                    }), 256))
                  ], 6))
                }), 256))
              ]),
              _createElementVNode("tbody", _hoisted_50, [
                _createElementVNode("tr", null, [
                  (_ctx.metaData.group_timeframe)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_51, " "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.dimensions, (d) => {
                    return (_openBlock(), _createElementBlock("td", _hoisted_52, " "))
                  }), 256)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metaData.metrics, (m) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass(["col-metric", 'col-'+m.name])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.summary[m.name].toLocaleString()), 1)
                    ], 2))
                  }), 256))
                ])
              ])
            ]),
            _createVNode(_component_pagination, {
              modelValue: _ctx.pagination,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pagination) = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}